import { useState } from 'react';

import type { AuthError } from '@/features/auth/shared/types/auth';
import { useSignIn, useSignUp } from '@clerk/clerk-react';

import { useCredentialsLogin } from './useCredentialsLogin';
import { useOAuthLogin } from './useOAuthLogin';

export const useLogin = () => {
  const [error, setError] = useState<AuthError | null>(null);
  const [loading, setLoading] = useState(false);

  const { isLoaded: isSignInLoaded } = useSignIn();
  const { isLoaded: isSignUpLoaded } = useSignUp();

  const { handleSocialLogin, isCreatingAccount, isOAuthReady, oauthLoading } = useOAuthLogin(setError, setLoading);

  const { submitEmail, submitPassword } = useCredentialsLogin(setError, setLoading);

  return {
    loading: loading || oauthLoading,
    error,
    isCreatingAccount: isCreatingAccount || oauthLoading,
    isClerkLoading: !isSignInLoaded || !isSignUpLoaded || !isOAuthReady,
    submitEmail,
    submitPassword,
    handleSocialLogin
  };
};
